import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { InfoStatusEnum } from '../../../enums/infoStatus.enum'

@Component({
  selector: 'app-soc-search-input',
  templateUrl: './soc-search-input.component.html',
  styleUrls: ['./soc-search-input.component.scss']
})
export class SocSearchInputComponent implements OnInit {

  @Input() label: string | null;
  @Input() alertLabel: string | null;
  @Input() status: InfoStatusEnum = InfoStatusEnum.Info;
  @Input() disabled: boolean;
  @Input() placeholder: string | null = 'Search...';
  @Input() searchValue: string = "";
  @Input() input: any;
  @Output() inputChange = new EventEmitter<string>();

  public infoStatusEnum = InfoStatusEnum;

  constructor() { }

  ngOnInit(): void {
  }

}
